import { useState, useEffect } from 'react';
import propTypes from 'prop-types';

const PaymentMethodLogoLoaderContainer = ({ filename, type, ...props }) => {
  const [state, setState] = useState({
    logo: null,
  });

  const { logo: Logo } = state;

  useEffect(() => {
    const importIcon = async () => {
      try {
        let logo;
        if (type === 'CARD') {
          logo = (
            await import(
              /* webpackMode: "lazy-once" */ `@eti/assets/logos/credit-cards/${filename}.svg`
            )
          ).ReactComponent;
        } else {
          logo = (
            await import(
              /* webpackMode: "lazy-once" */ `@eti/assets/logos/payment-methods/${filename}.svg`
            )
          ).ReactComponent;
        }

        setState({ logo });
      } catch (error) {
        console.error(`Could not load file ${filename}.svg`); // eslint-disable-line
      }
    };
    importIcon();
  }, [filename, type]);

  return Logo ? <Logo {...props} /> : <div />;
};

PaymentMethodLogoLoaderContainer.propTypes = {
  filename: propTypes.string,
  type: propTypes.string,
};

export default PaymentMethodLogoLoaderContainer;
